<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('dialog_label_bank_account_change') || '银行账号变更'"
      visible
      direction="rtl"
      :size="900"
      :before-close="() => $refs.main.cancel()"
      @close="close()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :custCode="custCode"
          @close="close"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer">
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('btn_submit_changes') || '提交变更' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    custCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
